import { useEffect } from "react";

import "./App.css";

import { Canvas } from "../../components/Canvas/Canvas";
import { RenderMain } from "../../webl/renderingMain";
import { FPSMeter } from "../../components/FPSMeter/FPSMeter";
import {
    GetAlanSub,
    GetHealthbar,
    GetLightswitchsubs,
    GetNicoleFullscreenText,
    GetPages,
    GetResidenceSub,
    GetStartScreen,
    IntroTextWrapper,
    NorseSubs,
} from "../../components/Titles/Hallway";
import { Footer } from "../../components/Footer/Footer";

function App() {
    useEffect(() => {
        RenderMain();
    }, []);

    return (
        <>
            <FPSMeter />
            <Footer />
            <Canvas />
            <IntroTextWrapper />
            <GetStartScreen />
            <NorseSubs />
            <GetLightswitchsubs />
            <GetResidenceSub />
            <GetNicoleFullscreenText />
            <GetHealthbar />
            <GetAlanSub />
            <GetPages />
        </>
    );
}

export default App;
